// Footer.js
import React, { useState } from 'react';
import './footer.css';

import { 
  FaCertificate, FaLeaf, FaSpa, FaMapMarkerAlt, FaPhoneAlt, 
  FaEnvelope, FaClock, FaPaperPlane, FaSpinner, FaArrowUp,
  FaFacebookF, FaInstagram, FaTripadvisor, FaWhatsapp,
  FaCcVisa, FaCcMastercard, FaCcAmex, FaCcPaypal,
  FaCcApplePay, FaGooglePay
} from 'react-icons/fa';

function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setStatus('loading');
    // Fake delay → in real app → API call
    setTimeout(() => {
      setStatus('success');
      setEmail('');
      alert('Thank you for subscribing!');
      setTimeout(() => setStatus('idle'), 4000);
    }, 1200);
  };

  const openSocial = (platform) => {
    const links = {
      facebook:    'https://facebook.com/elysianswellness',
      instagram:   'https://instagram.com/elysianswellness',
      tripadvisor: 'https://tripadvisor.com/elysianswellness',
    };
    if (links[platform]) window.open(links[platform], '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="footer">
      <img
        src="/footer b.jpeg"
        alt="Elysians Wellness Sanctuary background"
        className="footer-bg"
        loading="lazy"
      />

      <div className="footer-overlay">
        <div className="footer-container">

          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/logo - Elisians.png" alt="Elysians Wellness" loading="lazy" />
            </div>
            <p className="brand-text">
              Discover the healing power of authentic Ayurveda in the serene landscapes
              of Sri Lanka. Your path to holistic wellbeing starts here.
            </p>

            <div className="cert-badges">
              <div className="cert" title="ISO 9001 Certified"><FaCertificate /> ISO 9001</div>
              <div className="cert" title="Organic Certified"><FaLeaf /> Organic</div>
              <div className="cert" title="Authentic Ayurvedic Center"><FaSpa /> Ayurvedic</div>
            </div>
          </div>

          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/aboutus">About Us</a></li>
              <li><a href="/treatments">Treatments</a></li>
              {/* <li><a href="/gallery">Gallery</a></li> */}
              <li><a href="/contactus">Contact</a></li>
              <li><a href="/#">Wellness Blog</a></li>
              <li><a href="/#">FAQs</a></li>
              <li><a href="/#">Privacy Policy</a></li>
              <li><a href="/#">Terms of Use</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Visit Us</h4>
            <address>
              <p>No. 31, Tissa Road, Baddalandayaya, Wellawaya, Sri Lanka</p>
              <p>
                <a href="tel:+94705549750"><b>+94 70 554 9750</b></a><br />
                <a href="tel:+94712703920"><b>+94 71 270 3920</b></a>
              </p>
              <p>
                <a href="mailto:info@elysianswellness.lk"><b>info@elysianswellness.lk</b></a><br />
              </p>
              <p> Mon–Fri: 8AM–8PM<br />Sat–Sun: 9AM–6PM</p>
            </address>
          </div>

          <div className="footer-column newsletter-col">
            <h4>Stay Updated</h4>
            <p className="newsletter-hint">
              Exclusive offers, Ayurvedic tips & seasonal retreats
            </p>

            <form onSubmit={handleSubscribe} className="newsletter-form">
              <input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                disabled={status === 'loading'}
                aria-label="Email address for newsletter"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                aria-label="Subscribe"
              >
                {status === 'loading' ? <FaSpinner className="spin" /> : <FaPaperPlane />}
              </button>
            </form>

            <div className="social-icons">
              <button onClick={() => openSocial('facebook')} aria-label="Facebook">
                <FaFacebookF />
              </button>
              <button onClick={() => openSocial('instagram')} aria-label="Instagram">
                <FaInstagram />
              </button>
              <button onClick={() => openSocial('tripadvisor')} aria-label="TripAdvisor">
                <FaTripadvisor />
              </button>
              <a href="https://wa.me/94705549750" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
            </div>
          </div>

        </div> {/* .footer-container */}

        <hr className="footer-divider" />

        <div className="footer-bottom">
      {/* Copyright */}
      <div className="copyright">
        <p>&copy; {new Date().getFullYear()} Elysian Wellness. All Rights Reserved. |  Designed and Developed by 
  <a 
    className="glaxmore-link" 
    href="https://www.glaxmore.com" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    &ensp; GLAXMORE
  </a>
</p>
      </div>

          <div className="payment-icons">
            <FaCcVisa title="Visa" />
            <FaCcMastercard title="Mastercard" />
            {/* <FaCcAmex title="American Express" />
            <FaCcPaypal title="PayPal" />
            <FaCcApplePay title="Apple Pay" />
            <FaGooglePay title="Google Pay" /> */}
          </div>

          <button className="back-to-top" onClick={scrollToTop} aria-label="Scroll to top">
            <FaArrowUp /> Top
          </button>
        </div>

        {/* Optional subtle decoration */}
        <div className="footer-decor-leaf" aria-hidden="true" />
      </div>
    </footer>
  );
}

export default Footer;